import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { B06aSupplierInfoPage } from '../b06a-supplier-info/b06a-supplier-info';
import { B06bSupplierAddPage } from '../b06b-supplier-add/b06b-supplier-add';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B06SupplierPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface suppInfo{
  SUPPLIER_ID: number;
  SUPPLIER_CODE: string;
  SUPPLIER_NAME: string;
  ADDR1: string; 
  ADDR2: string; 
  ADDR3: string; 
  CONTACT_NO: string;                      
  EMAIL: string; 
  SUPPLIER_TYPE_ID: string;  
  TYPE: string;
  SUPPLIER_STATUS_ID: string;  
  STATUS: string;
}

@IonicPage()
@Component({
  selector: 'page-b06-supplier',
  templateUrl: 'b06-supplier.html',
})
export class B06SupplierPage {

  loading: any;
  Status: any;
  suppArr: suppInfo[] = [];
  suppItems: suppInfo[] = [];
  public errorMessage: any = "";
  public searchMessage:any = "";
  suppCode: any = "";
  suppName:any = "";
  GRP_ID: any;

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public serviceapi: ServiceApiProvider, private toastCtrl: ToastController, 
              public loadingCtrl: LoadingController) {

    this.GRP_ID = sessionStorage.getItem('usergroupid');

    let sortby= "No";
    let sorttype= "No";

    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["SUPPLIER_TYPE_ID", "SUPPLIER_STATUS_ID"];
    let fktbl = ["SUPPLIER_TYPE", "SUPPLIER_STATUS"];
    let fkkey = ["SUPPLIER_TYPE_ID", "SUPPLIER_STATUS_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"SUPPLIER","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.suppArr = Records;
        this.suppItems = this.suppArr;
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B06SupplierPage');
  }

  goToNewSupplier(){
    this.navCtrl.push(B06bSupplierAddPage);
  }

  editSupplier(ID){
    this.navCtrl.push(B06aSupplierInfoPage, {paramID: ID});         //Supplier ID
  }

  showLoader(){
  this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });

    this.loading.present();
  }

  clearItem(){
    this.suppCode = "";
    this.suppName = "";
  }

  searchItem(){
    this.searchMessage="";
    this.errorMessage="";

    let a;
    let b;
    let c;
    this.suppItems = [];

    let sortby= "No";
    let sorttype= "No";

    if (this.suppCode!=""){
      a = ["SUPPLIER"];
      b = ["SUPPLIER_CODE"];
      c = [this.suppCode];
      this.suppName="";
    }
    else if (this.suppName!=""){
      a = ["SUPPLIER"];
      b = ["SUPPLIER_NAME"];
      c = [this.suppName];
      this.suppCode="";
    }
    else {
      a = ["All"];
      b = ["All"];
      c = ["All"];
    }

    let tbl = a;
    let column = b;
    let value = c;
    
    let tblkey = ["SUPPLIER_TYPE_ID", "SUPPLIER_STATUS_ID"];
    let fktbl = ["SUPPLIER_TYPE", "SUPPLIER_STATUS"];
    let fkkey = ["SUPPLIER_TYPE_ID", "SUPPLIER_STATUS_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    console.log(json_data);
    this.serviceapi.readdata(json_data,"SUPPLIER","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.suppArr = Records;
        this.suppItems = this.suppArr;
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/b06-supplier/b06-supplier.ts